import { AutogenModelChargeCodeLookup, AutogenRowChargeCodeLookup } from "./autogen/AutogenModelChargeCodeLookup";

export class ModelChargeCodeLookup extends AutogenModelChargeCodeLookup<RowChargeCodeLookup> {
	constructor() {
		super(RowChargeCodeLookup);
	}
}

export class RowChargeCodeLookup extends AutogenRowChargeCodeLookup {
}